import React from 'react'
import BeautyStore from '../../../components /ProductPage/ItemsProduct/BeautyProduct'

const BeautyPage = () => {
  return (
    <div>
      <BeautyStore />
    </div>
  )
}

export default BeautyPage
